import { useCallback, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { HideSpinner, ShowSpinner } from "../redux/actions/SpinnerAction";
import * as CensusActions from "../redux/actions/CensusAction"
import _ from "lodash";
import { ErrorToast } from "../redux/actions/ToasterAction";
import { FormattedDateString } from "../utilities/DateHelper";
import { useHierarchyService } from "./useHierarchyService";
import { ExpandAll } from "../utilities/TreeHelper";


const useCensus = ({refreshTree = true})=>{  
    const {data:{selectedTreeNode}, actions:{GetMultipleLocationTreeWithFilter,  RefreshTree} }= useHierarchyService(); 
   
    const filter = useSelector((state)=>{
        return state.census.filter;
    })

    const isFilterApplied = useSelector((state)=>{
        return state.census.isFilterApplied;
    })

    const selectedLocations = useSelector((state)=>{
        return state.census.filter.selectedLocations
    })

    const defaultExpandedKeys = useSelector((state)=>{
        return state.census.defaultExpandedKeys;
    })

    const dispatchCensus = useDispatch();

    const InitializeDefaults = useCallback((date, selectedLocations)=>{
        var action = CensusActions.InitialDefaults(date, selectedLocations)
        dispatchCensus(action) 
    }, [dispatchCensus])

    const SetSelectedLocations = useCallback((selectedLocations)=>{
        var action = CensusActions.SetSelectedLocations(selectedLocations)
        dispatchCensus(action)
    }, [dispatchCensus])

    const SetSelectedDate = useCallback((date)=>{
        var action =  CensusActions.SetSelectedDate(date);       
        dispatchCensus(action);   

    }, [dispatchCensus])

    const SetFilter = useCallback((data)=>{
        var action =  CensusActions.SetFilter(data);       
        dispatchCensus(action);   

    }, [dispatchCensus])

    const ResetFilter = useCallback((data)=>{
        var action =  CensusActions.ResetFilter(data);       
        dispatchCensus(action);   

    }, [dispatchCensus])

    const SetDefaultExpandedKeys = useCallback((expandedKeys)=>{
        var action = CensusActions.SetDefaultExpandedKeys(expandedKeys);
        dispatchCensus(action);
    }, [dispatchCensus])

    const AssignOrReserveBed = useCallback(async(data)=>{
        try{
            dispatchCensus(ShowSpinner());     
            var action = await  CensusActions.AssignOrReserveBed(selectedTreeNode, data);
            dispatchCensus(HideSpinner());
            dispatchCensus(action); 
            await RefreshTree(filter)
        }  
        catch(err) {         
            dispatchCensus(HideSpinner());
            dispatchCensus(ErrorToast('Error', _.get(err, 'response.data.message')));
          }    

    }, [dispatchCensus, RefreshTree, filter, selectedTreeNode])

    const MoveClient = useCallback(async(data)=>{
        dispatchCensus(ShowSpinner());     
        var action = await  CensusActions.MoveClient(selectedTreeNode, data);
        dispatchCensus(HideSpinner());
        dispatchCensus(action);  
        await RefreshTree(filter)     

    }, [dispatchCensus, RefreshTree, filter, selectedTreeNode])


    const RemoveAssignOrReserve = useCallback(async (data)=>{
        dispatchCensus(ShowSpinner);
        var action = await  CensusActions.RemoveAssignOrReserve(selectedTreeNode, data);
        dispatchCensus(HideSpinner());
        dispatchCensus(action); 
        await RefreshTree(filter)  
    }, [dispatchCensus, RefreshTree, filter, selectedTreeNode])
   
    useEffect(()=>{       
        const GetTreeDataAsync = async ()=>{
            if(refreshTree && !_.isNull(filter.date) && !_.isEmpty(filter.selectedLocations)){         
                const treeData = await GetMultipleLocationTreeWithFilter({...filter, date:FormattedDateString(filter.date), locationIds:filter.selectedLocations.map((l)=>l.id)} ) 
                let expandedKeys = {};   
                isFilterApplied && _.forEach(treeData, (tree)=>{expandedKeys = {...expandedKeys, ...ExpandAll(tree, expandedKeys)}});
                SetDefaultExpandedKeys(expandedKeys)
            }
        }
        GetTreeDataAsync();
    }, [refreshTree, filter, isFilterApplied, GetMultipleLocationTreeWithFilter, SetDefaultExpandedKeys])

    return {data:{selectedLocations, filter, isFilterApplied, defaultExpandedKeys}, actions:{InitializeDefaults, SetSelectedLocations, SetSelectedDate, SetFilter, ResetFilter, AssignOrReserveBed, RemoveAssignOrReserve, MoveClient}}
}

export default useCensus